import { WEB_PHONE_FRAME_MAX_WIDTH_PX } from '@web/hooks/ui/use-wide-desktop-layout'

const DESIGN_WIDTH = 392
const DESIGN_HEIGHT = 852

const width = Math.min(window.innerWidth, WEB_PHONE_FRAME_MAX_WIDTH_PX)

// Высоту кэшируем на старте, как и width. Если брать window.innerHeight вживую, то при открытии
// клавиатуры она резко падает (innerHeight становится < width) → getScaleFactor уходит в ветку
// height/DESIGN_HEIGHT (~0.4) и ВЕСЬ контент масштабируется в минимум. Скейл дизайна не должен
// зависеть от клавиатуры, поэтому фиксируем высоту один раз.
const height = typeof window !== 'undefined' ? window.innerHeight : DESIGN_HEIGHT

function getScaleFactor() {
  if (typeof window === 'undefined') return 1

  const factor = width < height ? width / DESIGN_WIDTH : height / DESIGN_HEIGHT

  // Матчим native: не увеличиваем выше макета на desktop. Нижний порог не ставим — при
  // iOS Display Zoom viewport уже меньше макета, и clamp ломает вёрстку (контент вылезает снизу).
  return Math.min(factor, 1)
}

function scaleOnMiniDevices(scaledPixelSize: number, pixelSizeFromMockup: number) {
  const pick = pixelSizeFromMockup > scaledPixelSize ? Math.max : Math.min
  return pick(scaledPixelSize, pixelSizeFromMockup) * getScaleFactor()
}

export const rw = (num: number) => scaleOnMiniDevices((width * num) / DESIGN_WIDTH, num)

export const rh = (num: number) => scaleOnMiniDevices((height * num) / DESIGN_HEIGHT, num)

export const MAX_SYSTEM_FONT_SCALE = 1.15
export const MIN_SYSTEM_FONT_SCALE = 1

export function rf(num: number) {
  return rw(num)
}
